import Chat from '@material-ui/icons/Chat';
import DriveEta from '@material-ui/icons/DriveEta';
import Person from '@material-ui/icons/Person';
import ViewList from '@material-ui/icons/ViewList';
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import Edit from '@material-ui/icons/Edit';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';
import ImportExport from '@material-ui/icons/ImportExport';
import tag from 'clean-tag';
import ErrorBoundary from 'components/ErrorBoundary';
import RootModal from 'components/modal/RootModal';
import NotFound404 from 'components/NotFound404';
import RootNotification from 'components/notification/RootNotification';
import DrivingLessons from 'containers/driving';
import Status from 'containers/status';
import TheoryLessons from 'containers/theory';
import LessonsEdit from 'containers/lessonsEdit';
import LessonReport from 'containers/lessonReport';
import DataImport from 'containers/dataImport';
import { showModal } from 'ducks/modal';
import { getUser, logoutUser } from 'ducks/user';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// Init React-Dates datepicker
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { connect } from 'react-redux';
import { I18n, setLocale, Translate } from 'react-redux-i18n';
import { NavLink as ReactNavLink, Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Container, Flex, Image, NavLink, Provider as ThemeProvider, Truncate } from 'rebass';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { alignSelf, color, display, space, textAlign } from 'styled-system';
import { PvLinkWhite } from 'styles/CustomComponents';
import { default as theme } from 'theme';
import hasRole from 'util/hasRole';
import logo from './pv-logo.png';
import { formatCourse } from '../../util/FormatUtil';
import CourseSelect from '../course';

const Box = styled.div`
  ${space}
  ${color}
  ${display}
`;

const NavLinkSmall = NavLink.extend`
  ${alignSelf}
  ${space}
  ${display}
  transition: color .2s ease;
  &:hover {
    color: ${props => props.theme.colors.lighten[3]};
  }
`.withComponent(tag); // Removes alignself-attribute from the DOM to avoid an 'unknown attribute' warning from React

const PaddedNavLink = NavLink.extend`
  ${space}
  transition: background-color .2s ease;
  &:hover {
    background-color: rgba(0, 0, 0, .1);
  }
`;

const TruncateBox = Truncate.extend`
  ${textAlign}
  ${display}
`;

const MainNavLink = ({target, linkLabel, icon}) => {
  const Icon = icon
  return (
    <PaddedNavLink
      activeClassName="nav-active"
      py={[2, 2, 3]}
      className="nav"
      is={ReactNavLink}
      to={target}>
      <Box px={[1, 1, 2]} display={["block", "block", "none"]}>
        <Icon />
      </Box>
      <Box display={["none", "none", "block"]}>
        <Translate value={linkLabel}/>
      </Box>
    </PaddedNavLink>
  );
};
class ConnectedApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserInfo: true,
    };
  }

  componentWillMount() {
    this.props.getLoggedUser();
  }

  render() {
    const {
      showUserInfo
    } = this.state;

    const {
      changeLocale,
      history,
      logout,
      loggedUser,
      showModal,
      currentCourse
    } = this.props;

    const logoutClick = (e) => {
      e.preventDefault();
      showModal('CONFIRM', {
        confirmAction: () => logout(),
        confirmText: I18n.t('app.confirm_logout'),
      });
    };
    
    return (
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          <div className="App">
            <RootNotification />
            <Box mb={3} bg="green" color="white">
              <Box px={[2, 2, 3]} py={4}>
                <Flex flexWrap="wrap" alignItems="start">
                  <Image width={["100%", "50%", "40vw"]} src={logo} />
                  {loggedUser && (
                    <Box ml="auto" display={["none", "none", "block"]}>
                      <span>
                        {loggedUser.sn} {loggedUser.givenname}
                      </span>
                      <span> |</span>

                      <PvLinkWhite
                        className="nav"
                        px={1}
                        is={ReactNavLink}
                        to="/course"
                      >
                        <span>
                          {currentCourse ? (
                            formatCourse(currentCourse, true)
                          ) : (
                            <Translate value="course.no_selection" />
                          )}
                        </span>
                      </PvLinkWhite>
                      <span>| </span>
                      <PvLinkWhite href="#" px={1} onClick={logoutClick}>
                        <Translate value="app.logout" />
                      </PvLinkWhite>
                    </Box>
                  )}
                </Flex>
              </Box>
              <Container px={[2, 2, 3]} bg="green">
                <Flex justifyContent="space-between">
                  <Flex>
                    {!!loggedUser &&
                      hasRole(loggedUser, [
                        "KULTU_SEURANTA_ADMIN",
                        "KULTU_SEURANTA_KIRJAAJA",
                      ]) && (
                        <React.Fragment>
                          <MainNavLink target="/theory" linkLabel="app.theory_lessons_booking" icon={Chat}/>
                          <MainNavLink target="/training" linkLabel="app.training_lessons_booking" icon={Chat}/>
                          <MainNavLink target="/driving" linkLabel="app.driving_lessons_booking" icon={DriveEta}/>
                          <MainNavLink target="/report" linkLabel="app.study_overview" icon={ViewList}/>
                        </React.Fragment>
                      )}
                    <MainNavLink target="/status" linkLabel="app.lessons_status" icon={PlaylistAddCheck}/>
                    {!!loggedUser &&
                      hasRole(loggedUser, ["KULTU_SEURANTA_ADMIN"]) && (
                        <React.Fragment>
                          <MainNavLink target="/lessonsEdit" linkLabel="app.lessons_edit" icon={Edit}/>
                          <MainNavLink target="/dataimport" linkLabel="app.data_import" icon={ImportExport}/>
                        </React.Fragment>
                      )}
                  </Flex>
                  <Flex>
                    <NavLinkSmall
                      alignSelf="center"
                      className="nav"
                      px={1}
                      onClick={() => {
                        changeLocale("fi");
                      }}
                    >
                      <span>fi</span>
                    </NavLinkSmall>
                    <NavLinkSmall
                      alignSelf="center"
                      className="nav"
                      px={1}
                      onClick={() => {
                        changeLocale("en");
                      }}
                    >
                      <span>en</span>
                    </NavLinkSmall>
                    {loggedUser && (
                      <NavLinkSmall
                        p={[0, 1, 2]}
                        alignSelf="center"
                        className="nav"
                        display={["block", "block", "none"]}
                        onClick={() =>
                          this.setState({ showUserInfo: !showUserInfo })
                        }
                      >
                        <Person />
                      </NavLinkSmall>
                    )}
                    {loggedUser && (
                      <NavLinkSmall
                        p={[0, 1, 2]}
                        onClick={logoutClick}
                        alignSelf="center"
                        className="nav"
                        px={1}
                        display={["block", "block", "none"]}
                      >
                        <PowerSettingsNew />
                      </NavLinkSmall>
                    )}
                  </Flex>
                </Flex>
              </Container>
              {showUserInfo && loggedUser && (
                <TruncateBox
                  p={2}
                  textAlign="right"
                  display={["block", "block", "none"]}
                >
                  <span>
                    {loggedUser.sn} {loggedUser.givenname}
                  </span>
                  <span> |</span>
                  <PvLinkWhite
                    className="nav"
                    px={1}
                    is={ReactNavLink}
                    to="/course"
                  >
                    <span>
                      {currentCourse ? (
                        formatCourse(currentCourse, true)
                      ) : (
                        <Translate value="course.no_selection" />
                      )}
                    </span>
                  </PvLinkWhite>
                </TruncateBox>
              )}
            </Box>
            <ErrorBoundary>
              <Switch>
                
                {!loggedUser && (
                  <Redirect to="/login" />
                )}
                {!!loggedUser && (
                  <Redirect exact from="/login" to="/"/>
                )}
                <Route exact path="/course" component={CourseSelect} />
                <Route exact path="/lessonsEdit" component={LessonsEdit} />
                <Route exact path="/dataimport" component={DataImport} />
                {!!loggedUser && !currentCourse && (
                  <Redirect to="/course" />
                )}
               
                <Route exact path="/login" render={() => null} />
                <Route exact path="/theory" render={() => (<TheoryLessons lessonType="THEORY" />)} />
                <Route exact path="/training" render={() => (<TheoryLessons lessonType="TRAINING" />)} />
                <Route exact path="/driving" component={DrivingLessons} />
                <Route exact path="/status" component={Status} />
                <Route exact path="/report" component={LessonReport} />
                {!!loggedUser && hasRole(loggedUser, [
                    "KULTU_SEURANTA_ADMIN",
                    "KULTU_SEURANTA_KIRJAAJA",
                  ]) && <Redirect from="/" exact to="/theory" />}
                {!!loggedUser && !hasRole(loggedUser, [
                    "KULTU_SEURANTA_ADMIN",
                    "KULTU_SEURANTA_KIRJAAJA",
                  ]) && <Redirect from="/" exact to="/status" />}
                <Route component={NotFound404} />
              </Switch>
            </ErrorBoundary>
          </div>
          <RootModal />
        </ThemeProvider>
      </ConnectedRouter>
    );
  }
}

ConnectedApp.propTypes = {
  changeLocale: PropTypes.func,
  history: PropTypes.object.isRequired,
  loggedUser: PropTypes.object,
  logout: PropTypes.func,
  showModal: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    loggedUser: state.userState.user,
    currentCourse: state.userState.currentCourse
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  changeLocale: (locale) => {
    moment.locale(locale);
    return setLocale(locale);
  },
  getLoggedUser: () => getUser(),
  logout: () => logoutUser(),
  showModal: (modalType, modalProps) => showModal(modalType, modalProps),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedApp);



// WEBPACK FOOTER //
// ./src/containers/app/ConnectedApp.jsx